<template>
  <v-card
    class="ns-card vocabulary-card"
    :elevation="0"
    @click="$emit('select', card)"
  >
    <div class="card-title">
      <div class="card-header">
        <span class="jlpt-tag">{{ formattedJlpt }}</span>
      </div>
      <div class="card-caption">
        {{ card.word }}
      </div>
      <div
        v-if="card.reading"
        class="card-reading"
      >
        ( {{ card.reading }} )
      </div>
    </div>
    <hr class="card-divider">
    <p
      class="card-content card-content-ellipsis"
      :title="card.definition"
    >
      {{ card.definition }}
    </p>
  </v-card>
</template>

<script>
export default {
  name: "VocabularyCard",
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  emits: ['select'],
  computed: {
    formattedJlpt() {
      if (!this.card.jlpt) return 'JLPT N1';
      const match = this.card.jlpt.match(/^jlpt-(n\d)$/i);
      return match ? `JLPT ${match[1].toUpperCase()}` : this.card.jlpt.toUpperCase();
    }
  }
};
</script>

<style scoped>
.vocabulary-card {
  width: 80%;
  height: 200px;
  overflow: hidden;
  margin: var(--space-5);
  padding: var(--space-3) !important;
  cursor: pointer;
}

.card-header {
  width: 100%;
}

.card-reading {
  font-size: var(--font-size-base);
}

.card-caption {
  height: 50%;
  align-content: center;
  text-align: center;
  font-size: var(--font-size-base);
}

.card-title {
  display: grid;
}

.card-divider {
  border: none;
  border-top: 1px solid rgba(27,30,100,0.10);
  margin: var(--space-2) 0;
}

.card-content {
  align-content: center;
  font-size: var(--font-size-base);
}

.card-content-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  max-width: 100%;
}

.jlpt-tag {
  float: right;
  position: relative;
  top: 0;
  right: 0;
  margin-bottom: var(--space-4);
  margin-top: var(--space-4);
  background-color: var(--color-warning-light);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  color: var(--color-warning);
  font-weight: var(--font-weight-bold);
  text-align: center;
  z-index: 0;
}
</style>
